/// <reference path="../../../../../public/spreadsheet-viewer/sv/modern.vendors~spreadsheetviewer.8f5b4f56e651a83ae147.chunk.js" />
import React, { useEffect, useState } from 'react';
import * as CotplayHubActions from '../../../actions/CotplayHubActions';
import { useDispatch, useSelector } from 'react-redux';

// Styled Components:
import Grid from '@material-ui/core/Grid';
import { useStyles } from './CotplayHubVideoContainerStyles';
import { CotplayHubVideo } from './CotplayHubVideo';
import { Spin, Pagination } from 'antd';
import { Paper } from '@material-ui/core';

export const CotplayHubVideoContainer = (props) => {

    const classes = useStyles();
    const skin = 'amp-default';

    const loadLibrary = () => new Promise((resolve, reject) => {
        if (document.querySelector('#amp-azure')) return resolve()
        let scriptTag = document.createElement('script')
        let linkTag = document.createElement('link')
        linkTag.rel = 'stylesheet'
        scriptTag.id = 'amp-azure'
        linkTag.href = `${process.env.PUBLIC_URL}/azuremediaplayer.min.css`
        scriptTag.src = `${process.env.PUBLIC_URL}/azuremediaplayer.min.js`
        document.body.appendChild(scriptTag)
        document.head.insertBefore(linkTag, document.head.firstChild)
        scriptTag.onload = () => resolve({ skin: 'amp-default' })

    })

    // States:
    const {
        employeeId
    } = useSelector(state => state.Auth.employeeById);
    const {
        listMedia,
        isLoadingMedia,
        pagination,
        filter
    } = useSelector(state => state.CotplayHubReducer);
    const dispatch = useDispatch();

    // Effects:
    useEffect(() => {
        dispatch(CotplayHubActions.trainingNamesMediaVideo(false, employeeId));
        window.addEventListener('amp', loadLibrary(skin).then(() => {
            setTimeout(
                function () {
                    dispatch(CotplayHubActions.getMedia({ employeeId: employeeId, offset: 0, limit: 12 }))
                    dispatch(CotplayHubActions.getMedFilters({ employeeId: employeeId, offset: 0, limit: 0 }))

                },
                1
            );
        }))

    }, [dispatch]);

    const onChangePage = (current, pageSize) => {
        if (filter.idTraining !== undefined) {
            dispatch(CotplayHubActions.getMedia({
                isMostViewed: false,
                offset: (current - 1) * pageSize,
                limit: pagination.pageSize,
                idTraining: filter.idTraining,
                IdSpecialtyOrSystem: filter.idSystemSpecialty === undefined ? '' : filter.idSystemSpecialty
            }))
            dispatch(CotplayHubActions.getMedFilters({
                isMostViewed: false,
                offset: 0,
                limit: 0,
                idTraining: filter.idTraining,
                IdSpecialtyOrSystem: filter.idSystemSpecialty === undefined ? '' : filter.idSystemSpecialty
            }))
        } else {
            if (props.isMostViewed) {
                dispatch(CotplayHubActions.getMedia({
                    isMostViewed: true,
                    offset: (current - 1) * pageSize,
                    limit: pagination.pageSize
                }))
                dispatch(CotplayHubActions.getMedFilters({
                    isMostViewed: true,
                    employeeId: employeeId,
                    offset: 0,
                }))
            }
            else {
                dispatch(CotplayHubActions.getMedia({
                    employeeId: employeeId,
                    offset: (current - 1) * pageSize,
                    limit: pagination.pageSize
                }))
                dispatch(CotplayHubActions.getMedFilters({
                    employeeId: employeeId,
                    offset: 0,
                    limit: 0
                }))
            }
        }
    }

    const onChangePageSize = (current, pageSize) => {
        if (props.isMostViewed) {
            dispatch(CotplayHubActions.getMediaMostViewed(
                {
                    offset: (current - 1) * pageSize,
                    limit: pageSize,
                    idTraining: filter.idTraining === undefined ? '' : filter.idTraining,
                    IdSpecialtyOrSystem: filter.idSystemSpecialty === undefined ? '' : filter.idSystemSpecialty,
                }
            ))
            dispatch(CotplayHubActions.getMedFilters({
                isMostViewed: true,
                offset: 0,
                limit: 0,
                idTraining: filter.idTraining === undefined ? '' : filter.idTraining,
                IdSpecialtyOrSystem: filter.idSystemSpecialty === undefined ? '' : filter.idSystemSpecialty,
            }))
        } else {
            dispatch(CotplayHubActions.getMedia(
                {
                    employeeId: employeeId,
                    offset: (current - 1) * pageSize,
                    limit: pageSize,
                    idTraining: filter.idTraining === undefined ? '' : filter.idTraining,
                    IdSpecialtyOrSystem: filter.idSystemSpecialty === undefined ? '' : filter.idSystemSpecialty,
                }
            ))
            dispatch(CotplayHubActions.getMedFilters({
                employeeId: employeeId,
                offset: 0,
                limit: 0,
                idTraining: filter.idTraining === undefined ? '' : filter.idTraining,
                IdSpecialtyOrSystem: filter.idSystemSpecialty === undefined ? '' : filter.idSystemSpecialty,
            }))
        }
    }

    const [Height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });


    return (
        <Paper
            className={classes.MainHubContainer}
            style={{ height: (Height - 265) }}
        >
            <Spin spinning={isLoadingMedia ? true : false}>

                <Grid
                    className={
                        window.innerWidth > 1080
                            ?
                            classes.GridContainer
                            :
                            classes.GridContainerResp
                    }
                >
                    {
                        isLoadingMedia ? [] :
                            listMedia.map(videoItem => {
                                return (
                                    <CotplayHubVideo
                                        key={videoItem.rowNum}
                                        data={videoItem}
                                    />
                                )
                            })
                    }
                </Grid>

                <div className={classes.PaginationContainer}>
                    <Pagination
                        showSizeChanger
                        onChange={onChangePage}
                        defaultCurrent={1}
                        total={pagination.total}
                        current={pagination.current}
                        pageSize={pagination.pageSize}
                        pageSizeOptions={['12', '24', '36']}
                        onShowSizeChange={onChangePageSize}
                        showTotal={(total, range) => `${range[0]}-${range[1]} de ${total} registros`}
                    />
                </div>

            </Spin>
        </Paper>
    )
}
